import { create } from 'zustand'

interface PhotoesStore {
  frontPhoto: string
  rearPhoto: string
  clearPhotoes: () => void
  setFrontPhoto: (data: string) => void
  setRearPhoto: (data: string) => void
}

const usePhotoesStore = create<PhotoesStore>((set, get) => ({
  frontPhoto: '',
  rearPhoto: '',
  setFrontPhoto: (data: string) => set({ frontPhoto: data }),
  setRearPhoto: (data: string) => set({ rearPhoto: data }),
  clearPhotoes: () => set({ frontPhoto: '', rearPhoto: '' }),
}))

export default usePhotoesStore
